import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import DropdownActivator from 'scaleflow/utils/dropdown-activate';
import nameSort from 'scaleflow/utils/nameSort';

export default class InitiativesTableGoalSelectorComponent extends DropdownActivator {
  @service store;
  @tracked goalFormIsVisible = false;
  selectedInitiative = null;

  get initiative() {
    return this.args.initiative;
  }

  @action
  handleGoalsChange(initiative, e) {
    const goals = e.map((id) => this.store.peekRecord('goal', id));
    initiative.goals = goals;
    initiative.save();
  }

  @action
  toggleGoalForm(initiative, val) {
    if (initiative) this.selectedInitiative = initiative;
    else this.selectedInitiative = null;
    if (val !== undefined) this.goalFormIsVisible = val;
    else this.goalFormIsVisible = !this.goalFormIsVisible;
  }

  @action
  async onGoalAdded(goal) {
    const goals = [...this.selectedInitiative.goals.content];
    goals.push(goal);
    this.selectedInitiative.goals = goals;
    await this.selectedInitiative.save();
  }

  get goalsList() {
    const goals = this.store.peekAll('goal').map((item) => ({
      value: item.id,
      label: item.title,
    }));
    return goals;
  }

  get sortedGoals() {
    return this.initiative.goals?.content?.toSorted((a, b) =>
      nameSort(a.title, b.title, 'asc'),
    );
  }

  get firstGoal() {
    return this.sortedGoals?.[0];
  }

  willDestroy() {
    this.goalFormIsVisible = false;
    this.selectedInitiative = null;
    super.willDestroy(...arguments);
  }
}
